import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { filterEficienciaReprodutiva } from '../types/subTypes'

interface RootState {
    token: string,
    isAuthenticated: boolean,
    user: {},
    title: string,
    page_filter: filterEficienciaReprodutiva,
    help_text: string,
  };

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector